<template>
    <object type="image/svg+xml" 
        :data="require(`@/assets/icons/${icon}.svg`)" 
        v-bind:style="{'color':`${color}`}"
        :width="`${width}`"
    ></object>
</template>

<script>
  export default {
    name: 'DriblabIcon',
    props: {
        icon:{
            type:String,
            required:true
        },
        color:{
            type:String,
            default:"green"
        },
        width:{
            type:Number,
            default:20
        }
    },
    data() {
      return {
      }
    },
    watch: {
    },
    methods:{
    }
  }
</script>

<style lang="scss">
.driblab-icon{
    object,img{
        *{

            color:inherit;
        }
    }
}
</style>
